import appLocaleData from "react-intl/locale-data/en";
import en from "../locales/en-US";

const EnLang = {
  messages: {
    ...en
  },
  locale: "en-US",
  data: appLocaleData
};
export default EnLang;
